const axis = {
  X: 'x',
  Y: 'y',
};

export default axis;
